import { render, staticRenderFns } from "./SkuCollector.vue?vue&type=template&id=db080a38&"
import script from "./SkuCollector.vue?vue&type=script&lang=js&"
export * from "./SkuCollector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports